import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OverlayService } from '../../core/services/overlay.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { isEqual } from 'date-fns';
import { DecoratorOverlayService } from '../../core/utils/loader-decorator';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lbt-mobile',
  standalone: false,
  templateUrl: './mobile-layout.component.html',
  styleUrl: './mobile-layout.component.scss',
})
export class MobileLayoutComponent implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly matDialog = inject(MatDialog);

  protected readonly overlayService = inject(OverlayService);
  protected readonly decoratorOverlayService = inject(DecoratorOverlayService);

  private expireDialog: MatDialogRef<any> | null = null;

  @ViewChild('sessionExpiredTmpl') sessionExpiredTmpl!: TemplateRef<any>;

  private readonly onWindowScroll = () => window.scrollTo(0, 0);

  ngOnInit() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', this.onWindowScroll, { passive: true });

    this.authService.expiredRefreshToken$
      .pipe(take(1))
      .subscribe((date) => {
        this.openSessionExpired(date);
      });
  }

  ngOnDestroy() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  openSessionExpired(date: Date) {
    if (this.expireDialog) {
      return;
    }

    this.expireDialog = this.matDialog.open(this.sessionExpiredTmpl);

    this.expireDialog
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed
          && isEqual(date, this.authService.getRefreshTokenExpiresAt() as Date)) {
          this.authService.logOut();
        }
        this.expireDialog = null;
      });
  }
}
